import { render } from "./help.vue.js?vue&type=template&id=1c26855e!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./help.vue?vue&type=template&id=1c26855e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__